export const domReady = () =>
  new Promise((resolve) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", resolve, { once: true });
    } else {
      resolve();
    }
  });

export const ccmReady = () =>
  new Promise((resolve) => {
    if (typeof CCM !== "undefined") {
      resolve();
    } else {
      document.addEventListener("ccmReady", resolve, { once: true });
    }
  });
